import React, { useEffect, useState } from 'react';


const PaymentSuccessPage = () => {
    
    useEffect(() => {
        //
        console.log('callParentFunction.... REQUEST');
        window.parent.postMessage('callParentFunction', '*');
    }, [])

    return (
        <div style={{color: 'blue', fontSize: 26, textAlign: 'center', marginTop: 700}}>!התשלום בוצע בהצלחה</div>
    )
}
export default PaymentSuccessPage;